import { ChangeDetectionStrategy, Component, forwardRef } from '@angular/core';
import { LoginFormComponentDef } from '@df/session/login/login-form.component.def';
import { LoginFormContentComponent } from '../content/login-form-content.component';
import { LoginViewLayoutComponent } from '../view/layout/login-view-layout.component';
@Component({
    selector: 'login-form',
    templateUrl: './login-form.component.html',
    standalone: true,
    imports: [LoginViewLayoutComponent, forwardRef(() => LoginFormContentComponent)],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class LoginFormComponent extends LoginFormComponentDef {}
